import { EventFilter, EventSort } from '@/features/BrowseBar';
import type { EventsBrowseBarConfig } from '@/features/BrowseBar';

export const EVENTS_CONFIG: EventsBrowseBarConfig = {
    filters: [
        EventFilter.DATE_RANGE,
        EventFilter.SOURCE,
        EventFilter.OBJECT_TYPE,
    ],
    sorts: [EventSort.DATE],
};
